import type { TableColumnSort } from '@ipfabric/utils';
import { ApiTablePage } from 'components/ApiTablePage/ApiTablePage';
import { createFrontendOnlyColumn } from 'components/Table/columns/frontendOnlyColumn';
import { useLocale } from 'containers/App/LocaleContext';
import { DownloadReport } from 'containers/DownloadReport/DownloadReport';
import { memo } from 'react';
import type { FC } from 'react';
import { useTableEndpoint } from 'utils/table/useTableEndpoint';

export const networkAnalysisReportApiEndpoint =
  '/tables/management/discovery-runs';

const initialSort: TableColumnSort = { column: 'tsStart', order: 'desc' };

const BareNetworkAnalysisReportPage: FC = () => {
  const { networkAnalysisReport: networkAnalysisReportMsg } = useLocale();

  const endpoint = useTableEndpoint({
    apiEndpoint: networkAnalysisReportApiEndpoint,
    alternative: {
      id: '/reports/network-analysis-report',
      title: networkAnalysisReportMsg.tableTitle,
      columns: [
        '...',
        createFrontendOnlyColumn({
          key: 'action',
          disabledSort: true,
          title: networkAnalysisReportMsg.actionColumnTitle,
          webDependencies: ['id', 'status'],
          render: (row) => (
            <DownloadReport
              snapshot={row.id}
              disabled={row.status !== 'done'}
            />
          ),
        }),
      ],
    },
  });

  return (
    <ApiTablePage
      tableClassName='m'
      endpoint={endpoint}
      additionalApiTableProps={{
        initialSort,
        tableDescription: networkAnalysisReportMsg.tableHelp,
      }}
    />
  );
};

export const NetworkAnalysisReportPage = memo(BareNetworkAnalysisReportPage);
